import { CompanySizeOption } from 'signup-constants/signupData/CompanySizeOption';
import { Data } from 'signup-constants/signupData/Data';
import { ExperimentKeys } from '../../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../../experiments/ExperimentParameterGroup';
import { NextStepManager } from '../../flow-management/NextStepManager';
import { getIsActiveAndAssignedToVariant } from '../../store/experiments/selectors';
import { getCurrentStep } from '../../store/flow/selectors';
import { bulkSetSignupDataAndSetValidAndCompleted } from '../../store/signup-data/action-creators';
import { getSignupDataValue } from '../../store/signup-data/selectors';
import { Step } from 'signup-constants/Step';
import { UserSizeOption } from 'signup-constants/signupData/UserSizeOption';
import { ManagementLevel } from 'signup-constants/signupData/ManagementLevel';
export const BranchACQ143CompanySize = {
  name: 'BranchACQ143CompanySize',
  stateCheck: state => {
    return getSignupDataValue(state, Data.CompanySize) === CompanySizeOption.One && getCurrentStep(state) === Step.CompanySize && getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0143, [ExperimentParameterGroup.Variant_A]);
  },
  rebuildFlow: (flow, state, dispatch) => {
    dispatch(bulkSetSignupDataAndSetValidAndCompleted({
      [Data.UserSize]: UserSizeOption.One
    }));
    dispatch(bulkSetSignupDataAndSetValidAndCompleted({
      [Data.ManagementLevel]: ManagementLevel.Owner
    }));
    const nextSteps = NextStepManager.removeSteps(Step.UserSize, Step.ManagementLevel)(flow);
    return nextSteps;
  },
  processed: false,
  processedOnStep: Step.CompanySize,
  afterData: null,
  afterStep: null
};